/**
 * Capa de dispositivo de la app móvil (spec §3.3).
 *
 * Punto único de entrada. Las pantallas importan desde aquí y nunca desde
 * `navigator.*` directamente — esa disciplina es lo que permite cambiar el
 * adaptador por su equivalente nativo al envolver con Capacitor sin tocar una sola
 * pantalla.
 */

export {
  createUuid,
  deviceFail,
  deviceOk,
  isBrowser,
  type DeviceFailureReason,
  type DeviceResult,
} from "./types";

export {
  getConnectionQuality,
  isOnline,
  prefersReducedData,
  subscribeToNetwork,
  type ConnectionQuality,
} from "./network";

export {
  distanceInMeters,
  getCurrentPosition,
  getLocationPermission,
  watchPosition,
  type DevicePosition,
  type LocationPermission,
  type PositionOptions,
} from "./geolocation";

export {
  DeviceStorageError,
  isStorageAvailable,
  requestPersistentStorage,
} from "./storage";

export { getOrCreateDeviceId } from "./deviceId";

export {
  discardOutboxItem,
  enqueue,
  flushOutbox,
  getOutboxSnapshot,
  outboxFailureMessage,
  registerOutboxModule,
  retryOutboxItem,
  startOutboxSync,
  subscribeToOutbox,
  type OutboxFailureKind,
  type OutboxFlushSummary,
  type OutboxItem,
  type OutboxItemStatus,
  type OutboxModule,
  type OutboxSendResult,
  type OutboxSender,
  type OutboxSnapshot,
} from "./outbox";

export {
  getNotificationPermission,
  getPushSubscription,
  isInstalledPwa,
  isIosDevice,
  isPushSupported,
  pushRequiresInstall,
  requestNotificationPermission,
  setAppBadgeCount,
  subscribeToPush,
  unsubscribeFromPush,
  type NotificationPermissionState,
} from "./notifications";

export {
  capturePhoto,
  compressPhoto,
  isCameraSupported,
  photoToDataUrl,
  pickPhoto,
  type PhotoOptions,
} from "./camera";
